import { inject, Injectable } from '@angular/core';
import FormService, { FormDefinition } from '../forms/forms.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NextFormService {
  private formService = inject(FormService);
  #key = 'next_forms';
  setNextForms(nextFormsIds: string[]) {
    localStorage.setItem(this.#key, JSON.stringify(nextFormsIds));
  }

  reset() {
    this.setNextForms([]);
  }

  get nextForms(): Observable<{ name: string; _id: string }[]> {
    const savedFormsIds = this.getNextForms();

    return this.formService.findMany(savedFormsIds);
  }

  getNextForms(): string[] {
    return JSON.parse(localStorage.getItem(this.#key) || '[]');
  }

  hasNextForms(): boolean {
    return this.getNextForms().length > 0;
  }

  done(formDefinitionId: string) {
    this.setNextForms(this.getNextForms().filter((form) => form !== formDefinitionId));
  }
}
